import { useCallback } from 'react';

import RequestState from "../../types/RequestState";

const useShippingDetails = ({ activeProductId }) => {
  /**
   *
   * @param {Object} props
   * @param {ProductStore} props.productStore
   * @param {Object} props.fetchParams
   * @param {Object} props.fetchParams.id
   * @param {Object} props.fetchParams.urlParams
   * @param {String} props.fetchParams.state
   */
  const fetchShippingDetails = useCallback(
    ({ product }) => {
      if (!product) {
        return;
      }
      const loadingState = product.getActualProductLoadingState({ id: activeProductId, state: 'shippingStates' });

      if (loadingState !== RequestState.LOADING) {
        product
          .loadShippingDetails({
            activeId: activeProductId,
            state: 'shippingStates',
          })
          .catch((e) => {
            console.error(e);
          });
      }
    },
    [activeProductId]
  );

  return [fetchShippingDetails];
};

export default useShippingDetails;
